module.exports = __webpack_public_path__ + "img/doctor_step2_1.5e62bf55.png";